var exports = {
  "kL": "Tabs.module__container___UVlsWm",
  "Mf": "Tabs.module__tab___UVlsWm",
  "wH": "Tabs.module__selected___UVlsWm",
};

module.exports = exports;
